import {
  initGoogleTagManager,
  isGoogleTagManagerInitialized,
  parseGoogleTagManagerConfig,
  trackGtmPageView,
  updateGoogleTagManagerConsent,
} from '~/utils/googleTagManager'
import { markTrackingLoaded } from '~/utils/trackingScope'

export default defineNuxtPlugin(async () => {
  const { fetchSettings, settings, loaded } = useSiteSettings()
  const { analytics, marketing, hydrate } = useCookieConsent()
  const { trackableShop } = useTrackingScope()
  const router = useRouter()

  if (!loaded.value) {
    await fetchSettings()
  }

  hydrate()

  function syncConsent() {
    if (!isGoogleTagManagerInitialized()) return
    updateGoogleTagManagerConsent({
      analytics: analytics.value,
      marketing: marketing.value,
    })
  }

  // Consent Mode v2: the container loads immediately with all storage denied by
  // default, then we grant/deny based on the user's cookie choices.
  function syncGoogleTagManager() {
    if (isGoogleTagManagerInitialized()) return
    const slug = trackableShop()
    if (!slug) return

    const config = parseGoogleTagManagerConfig(settings.value.google_tag_manager)
    if (!config.enabled || !config.containerIds.length) return

    markTrackingLoaded(slug)
    initGoogleTagManager(config.containerIds)
    syncConsent()
  }

  watch([loaded, () => router.currentRoute.value.path], syncGoogleTagManager, { immediate: true })
  watch([analytics, marketing], syncConsent)

  router.afterEach((to) => {
    if (!trackableShop(to)) return
    trackGtmPageView(to.fullPath)
  })
})
